import { createModuleOptions, openModuleNamespaced } from "@/store/lib";

export const onresizeModule = createModuleOptions({
  state: {
    resizeTimestamp: 0,
    resizeEvent: new Event("onresize"),
  },
  getters: {
    timestamp(state) {
      return state.resizeTimestamp;
    },
    event(state) {
      return state.resizeEvent;
    },
  },
  mutations: {
    updateTimestamp(state, event: Event) {
      state.resizeEvent = event;
      state.resizeTimestamp = Date.now();
    },
  },
  actions: {
    updateTimestamp({ commit }, event: Event) {
      commit("updateTimestamp", event);
    },
  },
});

export default createModuleOptions({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    onresize: openModuleNamespaced(onresizeModule),
  },
});
